import { fetchAPI, API_BASE_URL } from "./apiCore";
import { getToken, getuserId } from "./auth";


// Fetch Terms and Conditions
export const fetchTermsAndConditions = async () => {
  return fetchAPI("general/terms-and-conditions", "GET");
};

